<template>
  <div class="modal fade" :id="id" tabindex="-1" role="dialog" style="display: none;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
            aria-hidden="true">×</span></button>
          <h4 class="modal-title">{{'avis_will_be_created' | translate}}</h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-xs-12">
              <template v-if="!loaded">
                <span>
                  <i class="fa fa-spinner fa-spin"></i>
                </span>
              </template>
              <template v-else>
                <span>
                  <strong>CPD: </strong><span>{{configData.sap_cpd_code}}</span><br/>
                  <span><strong>Finanzzwischenkonten: </strong></span><br>
                  <strong>hkont: </strong><span>{{configData.hkont}}</span><br/>
                  <strong>saknr: </strong><span>{{configData.saknr}}</span>
                </span>
              </template>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="col-xs-12" >
            <button class="btn btn-danger"  data-dismiss="modal" @click="$emit('modalClicked','')" id="buttonCancel">
              Abbrechen
            </button>
            <button class="btn btn-success"  data-dismiss="modal" @click="$emit('modalClicked','ok')" id="buttonOk"> OK
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      loaded: {
        type: Boolean,
        default: false
      },
      id: {
        type: String,
        default: 'AvisCreationModal'
      },
      configData: {
        type: Object,
        default: () => {
          return false
        }
      }
    },
    data() {
      return {}
    },
    methods: {},
    mounted() {
    },
    watch: {
      configData() {
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/tools/Modals/AvisCreationModal.vue